import { AsarFormikInput, AsarFormikSelect } from "@/components";
import { Grid } from "@mui/material";
import { useMemo } from "react";

function GroupInfo() {
  const [
    lodgmentOptions,
    tripFrequencyOptions,
    groupRegistrationPlaceOptions,
    tripRadiusOptions,
    establishYearOptions,
  ] = useMemo(() => [
    [
      { id: "OFFICE", label: "دفتر خصوصی" },
      { id: "MOSQUE", label: "مسجد" },
      { id: "UNIVERSITY", label: "دانشگاه" },
      { id: "BASIJ", label: "دفتر بسیج" },
      { id: "OTHER", label: "سایر" },
    ],
    [
      { id: "ALWAYS", label: "دائمی" },
      { id: "WEEKLY", label: "هفتگی" },
      { id: "MONTHLY", label: "ماهانه" },
      { id: "SEASONAL", label: "فصلی" },
      { id: "TWICE_IN_YEAR", label: "دوبار در سال" },
      { id: "YEARLY", label: "سالانه" },
    ],
    [
      { id: "UNIVERSITY_BASIJ", label: "بسیج دانشجویی" },
      { id: "MEDICAL_BASIJ", label: "بسیج جامعه پزشکی" },
      { id: "DISTINCT_BASIJ", label: "بسیج محلات" },
      { id: "OTHER_BASIJ", label: "دیگر بسیج‌ها" },
      { id: "COUNTRY_MINISTRY", label: "وزارت کشور" },
      { id: "MEDICAL_MINISTRY", label: "وزارت بهداشت" },
      { id: "SEPAH", label: "سپاه" },
      { id: "OTHER", label: "سایر" },
    ],
    [
      { id: "SPECIFIC_POINT", label: "در یک نقطه ثابت" },
      { id: "SPECIFIC_DISTINCT", label: "در یک محله" },
      { id: "SPECIFIC_CITY", label: "در یک شهر" },
      { id: "SPECIFIC_PROVINCE", label: "در یک استان" },
      { id: "COUNTRY", label: "کشوری" },
      { id: "INTERNATIONAL", label: "بین المللی" },
    ],
    [
      { id: "1350", label: "1350" },
      { id: "1351", label: "1351" },
      { id: "1352", label: "1352" },
      { id: "1353", label: "1353" },
      { id: "1354", label: "1354" },
      { id: "1355", label: "1355" },
      { id: "1356", label: "1356" },
      { id: "1357", label: "1357" },
      { id: "1358", label: "1358" },
      { id: "1358", label: "1358" },
      { id: "1360", label: "1360" },
      { id: "1361", label: "1361" },
      { id: "1362", label: "1362" },
      { id: "1363", label: "1363" },
      { id: "1364", label: "1364" },
      { id: "1365", label: "1365" },
      { id: "1366", label: "1366" },
      { id: "1367", label: "1367" },
      { id: "1367", label: "1367" },
      { id: "1368", label: "1368" },
      { id: "1370", label: "1370" },
      { id: "1370", label: "1370" },
      { id: "1372", label: "1372" },
      { id: "1373", label: "1373" },
      { id: "1374", label: "1374" },
      { id: "1375", label: "1375" },
      { id: "1376", label: "1376" },
      { id: "1377", label: "1377" },
      { id: "1378", label: "1378" },
      { id: "1379", label: "1379" },
      { id: "1380", label: "1380" },
      { id: "1381", label: "1381" },
      { id: "1382", label: "1382" },
      { id: "1383", label: "1383" },
      { id: "1384", label: "1384" },
      { id: "1385", label: "1385" },
      { id: "1386", label: "1386" },
      { id: "1387", label: "1387" },
      { id: "1388", label: "1388" },
      { id: "1389", label: "1389" },
      { id: "1390", label: "1390" },
      { id: "1391", label: "1391" },
      { id: "1392", label: "1392" },
      { id: "1393", label: "1393" },
      { id: "1394", label: "1394" },
      { id: "1395", label: "1395" },
      { id: "1396", label: "1396" },
      { id: "1397", label: "1397" },
      { id: "1398", label: "1398" },
      { id: "1399", label: "1399" },
      { id: "1400", label: "1400" },
      { id: "1401", label: "1401" },
      { id: "1402", label: "1402" },
      { id: "1403", label: "1403" },
      { id: "1404", label: "1404" },
    ],
  ]);

  return (
    <>
      <Grid display={"flex"} flexDirection={"column"} width={"100%"} gap="10px">
        <Grid
          gap="10px"
          width={"100%"}
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
        >
          <AsarFormikInput
            type="number"
            label={"تعداد کل اردوها"}
            name={"totalTrips"}
            placeholder="تعداد را وارد نمایید"
          />

          <AsarFormikInput
            type="number"
            label={"تعداد اردوهای سال اخیر"}
            name={"recentTrips"}
            placeholder="تعداد را وارد نمایید"
          />
        </Grid>
        <Grid
          gap="10px"
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
        >
          <AsarFormikInput
            type="number"
            label={"تعداد کل جهادگران"}
            name={"totalMembers"}
            placeholder="تعداد را وارد نمایید"
          />

          <AsarFormikInput
            type="number"
            label={"تعداد جهادگران فعال"}
            name={"recentMembers"}
            placeholder="تعداد را وارد نمایید"
          />
        </Grid>

        <Grid
          gap="10px"
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
        >
          <AsarFormikInput
            type="number"
            label={"تعداد روز اردو"}
            name={"tripDays"}
            placeholder="تعداد را وارد نمایید"
          />

          <AsarFormikInput
            type="number"
            label={"تعداد کل مناطق"}
            name={"regionsCount"}
            placeholder="تعداد را وارد نمایید"
          />
        </Grid>

        <Grid
          gap="10px"
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
        >
          <AsarFormikInput
            type="number"
            label={"تعداد نفر اردو"}
            name={"membersPerTrip"}
            placeholder="تعداد را وارد نمایید"
          />

          <AsarFormikInput
            type="number"
            label={"تعداد افراد تیم مدیریتی شما"}
            name={"managersCount"}
            placeholder="تعداد را وارد نمایید"
          />
        </Grid>

        <Grid
          gap="10px"
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
        >
          <AsarFormikSelect
            data={establishYearOptions}
            name={"establishYear"}
            label={"سال تاسیس گروه"}
            placeholder="انتخاب کنید"
          />
          <AsarFormikInput
            type="number"
            name={"atlasCode"}
            label={"کداطلس جهادگران یا شناسه ملی"}
            placeholder="کداطلس یا شناسه ملی را وارد نمایید"
          />
        </Grid>

        <Grid
          gap="10px"
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
        >
          <AsarFormikSelect
            data={lodgmentOptions}
            name={"lodgment"}
            label={"محل استقرار گروه"}
            placeholder="انتخاب کنید"
          />
          <AsarFormikSelect
            data={tripFrequencyOptions}
            name={"tripFrequency"}
            label={"بسامد برگزاری اردوها"}
            placeholder="انتخاب کنید"
          />
        </Grid>

        <Grid
          gap="10px"
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
        >
          <AsarFormikSelect
            data={groupRegistrationPlaceOptions}
            name={"groupRegistrationPlace"}
            label={"محل ثبت نام"}
            placeholder="انتخاب کنید"
          />
          <AsarFormikSelect
            data={tripRadiusOptions}
            name={"tripRadius"}
            label={"شعاع برگزاری اردو"}
            placeholder="انتخاب کنید"
          />
        </Grid>

        <AsarFormikInput
          label="آدرس سایت"
          name={"site"}
          placeholder="آدرس سایت گروه جهادی را وارد نمایید"
        />

        <AsarFormikInput
          name={"address"}
          label="نشانی پایگاه"
          placeholder={"نشانی پایگاه را بطور کامل وارد نمایید"}
        />

        <AsarFormikInput
          name={"pageAddress"}
          label={"آدرس پیج"}
          placeholder="آدرس پیج گروه جهادی را وارد نمایید."
        />

        <AsarFormikInput
          name={"platform"}
          label={"پلت‌فرم"}
          placeholder="پلت‌فرم را وارد نمایید"
        />

        <AsarFormikInput
          type="number"
          maxLength={11}
          name={"tel"}
          label={"تلفن ثابت"}
          placeholder="شماره تلفن ثابت دفتر را وارد نمایید"
        />
      </Grid>
    </>
  );
}

export default GroupInfo;
